import React from 'react'
import Slide from '@material-ui/core/Slide'

import BkFlowRoomCardRateStagePriceCollection from './BkFlowRoomCardRateStagePriceCollection'
import BkFlowRoomCardRateStagePriceButton from './BkFlowRoomCardRateStagePriceButton'
import BkFlowRoomCardRateStageDetails from './BkFlowRoomCardRateStageDetails'

import yn from 'yn'
import _ from 'lodash'

import backArrow from '../../../../assets/icons/arrow-left.svg'

const BkFlowRoomCardRateStage = props => {
	const {
		activeCurrencyData,
		adaDescriptionEvent,
		adaDescriptionExpanded,
		cards,
		currentRateCode,
		currentUpSells,
		gallery,
		hotelLabels,
		isTaxInclusiveProperty,
		payFeaturedRoomRates,
		payLaterRatePlan,
		payLaterRoomRate,
		payNowRatePlan,
		payNowRoomRate,
		payPromoRatePlan,
		payPromoRoomRate,
		queriedRatePlan,
		queriedRoomRate,
		ratePlanData,
		roomGroup,
		roomRateStageEvent,
		roomRateStageExpanded,
		toggleActiveRoom,
		totalNights,
		upSellsToggleEvent,
		urlData,
	} = props

	let roomTypeName = null,
			roomTypePriceButtons = [],
			renderFeaturedRateToggles = []

	if (
		cards &&
		cards.roomDescription &&
		cards.roomDescription.name
	) {
		roomTypeName = cards.roomDescription.name
	}

	if (!_.isEmpty(payFeaturedRoomRates)) {
		for (const rateKey in payFeaturedRoomRates) {
			const currentFeaturedRate = payFeaturedRoomRates[rateKey]

			if (
				currentFeaturedRate.roomRateData &&
				currentFeaturedRate.ratePlanData
			) {
				renderFeaturedRateToggles.push(
					<BkFlowRoomCardRateStagePriceButton
						key={'featured-room-rate-' + rateKey}
						activeCurrencyData={ activeCurrencyData }
						currentRateCode={ currentRateCode }
						currentUpSells={currentUpSells}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						totalNights={ totalNights }
						roomGroup={ roomGroup }
						roomRateData={ currentFeaturedRate.roomRateData }
						ratePlanData={ currentFeaturedRate.ratePlanData }
						toggleActiveRoom={ toggleActiveRoom }
						upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
					/>
				)
			}
		}
	}

	if (yn(process.env.REACT_APP_COMPONENT_ENABLE_CONFIGURED_RATE_SORTING)) {
		roomTypePriceButtons.push(
			<div
				key={ 0 }
				className="bk-flow-room__pricing-buttons"
			>
				{ payNowRoomRate && payNowRatePlan &&
					<BkFlowRoomCardRateStagePriceButton
						key={ payNowRoomRate.ratePlanCode }
						activeCurrencyData={ activeCurrencyData }
						currentRateCode={ currentRateCode }
						currentUpSells={currentUpSells}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						totalNights={ totalNights }
						roomGroup={ roomGroup }
						roomRateData={ payNowRoomRate }
						ratePlanData={ payNowRatePlan }
						toggleActiveRoom={ toggleActiveRoom }
						upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
					/>
				}

				{ payLaterRoomRate && payLaterRatePlan &&
					<BkFlowRoomCardRateStagePriceButton
						key={ payLaterRoomRate.ratePlanCode }
						activeCurrencyData={ activeCurrencyData }
						currentRateCode={ currentRateCode }
						currentUpSells={currentUpSells}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						totalNights={ totalNights }
						roomGroup={ roomGroup }
						roomRateData={ payLaterRoomRate }
						ratePlanData={ payLaterRatePlan }
						toggleActiveRoom={ toggleActiveRoom }
						upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
					/>
				}

				{ !_.isEmpty(renderFeaturedRateToggles) &&
					renderFeaturedRateToggles
				}
			</div>
		)
	} else if (
		urlData &&
		urlData.ratePlanCode &&
		queriedRoomRate &&
		queriedRatePlan
	){
		// Set specific rate plan code to top if parameter valid
		roomTypePriceButtons.push(
			<BkFlowRoomCardRateStagePriceButton
				key={ queriedRoomRate.ratePlanCode }
				activeCurrencyData={activeCurrencyData}
				currentRateCode={currentRateCode}
				currentUpSells={currentUpSells}
				isTaxInclusiveProperty={isTaxInclusiveProperty}
				totalNights={totalNights}
				roomGroup={roomGroup}
				roomRateData={queriedRoomRate}
				ratePlanData={queriedRatePlan}
				toggleActiveRoom={toggleActiveRoom}
				upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
			/>
		)
	} else if (
		urlData &&
		urlData.promoCode &&
		queriedRoomRate &&
		queriedRatePlan
	){
		// Set specific rate plan code to top if parameter valid
		roomTypePriceButtons.push(
			<BkFlowRoomCardRateStagePriceButton
				key={ queriedRoomRate.ratePlanCode }
				activeCurrencyData={activeCurrencyData}
				currentRateCode={currentRateCode}
				currentUpSells={currentUpSells}
				isTaxInclusiveProperty={isTaxInclusiveProperty}
				totalNights={totalNights}
				roomGroup={roomGroup}
				roomRateData={payPromoRoomRate}
				ratePlanData={payPromoRatePlan}
				toggleActiveRoom={toggleActiveRoom}
				upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
			/>
		)
	} else if (
		cards &&
		cards.viewExtensions &&
		cards.viewExtensions.roomRates &&
		yn(process.env.REACT_APP_COMPONENT_ENABLE_PARENT_CHILD_RATE_SORTING)
	) {
		const roomRates = cards.viewExtensions.roomRates
		let parentRoomRates = [],
				childRoomRates = []

		// Construct arrays of parent and children roomRates based on viewExtension existing
		for (const rateKey in roomRates) {
			let hasParentRate = false

			const roomRate = roomRates[rateKey]

			if (
				roomRate &&
				roomRate.viewExtensions &&
				roomRate.viewExtensions.parentRatePlanCode
			) {
				hasParentRate = true
			}

			if (hasParentRate) {
				childRoomRates.push(roomRate)
			} else {
				parentRoomRates.push(roomRate)
			}
		}

		// Display parent rates, and pass applicable child roomRate & ratePlan to parent component
		for (const rateKey in parentRoomRates) {
			const parentRoomRate = parentRoomRates[rateKey],
						parentRatePlan = ratePlanData.filter(function(rate) {
							return rate.ratePlanCode === parentRoomRate.ratePlanCode
						}),
						childRoomRate = childRoomRates.filter(function(rate) {
							return rate.viewExtensions.parentRatePlanCode === parentRoomRate.ratePlanCode && rate.roomTypeCode === parentRoomRate.roomTypeCode
						})

			let childRatePlan = null

			if (
				childRoomRate &&
				childRoomRate[0]
			) {
				childRatePlan = ratePlanData.filter(function(rate) {
					return rate.ratePlanCode === childRoomRate[0].ratePlanCode
				})
			}

			if (
				childRoomRate &&
				childRoomRate[0] &&
				childRatePlan &&
				childRatePlan[0]
			) {
				roomTypePriceButtons.push(
					<BkFlowRoomCardRateStagePriceCollection
						key={ parentRoomRate.ratePlanCode }
						activeCurrencyData={activeCurrencyData}
						currentRateCode={currentRateCode}
						currentUpSells={currentUpSells}
						totalNights={totalNights}
						roomGroup={roomGroup}
						roomRateData={parentRoomRate}
						ratePlanData={parentRatePlan[0]}
						toggleActiveRoom={toggleActiveRoom}
						childRoomRateData={childRoomRate && childRoomRate[0] && childRoomRate[0]}
						childRatePlanData={childRatePlan && childRatePlan[0] && childRatePlan[0]}
						upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
					/>
				)
			} else {
				roomTypePriceButtons.push(
					<BkFlowRoomCardRateStagePriceButton
						key={ parentRoomRate.ratePlanCode }
						activeCurrencyData={activeCurrencyData}
						currentRateCode={currentRateCode}
						currentUpSells={currentUpSells}
						isTaxInclusiveProperty={isTaxInclusiveProperty}
						totalNights={totalNights}
						roomGroup={roomGroup}
						roomRateData={parentRoomRate}
						ratePlanData={parentRatePlan[0]}
						toggleActiveRoom={toggleActiveRoom}
						upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
					/>
				)
			}
		}
	} else if (
		cards &&
		cards.viewExtensions &&
		cards.viewExtensions.roomRates
	) {
		const rates = _.get(cards, 'viewExtensions.roomRates', [])
    const nonMemberRates = _.filter(rates, rate => rate.ratePlanType !== 'MEMBER')

		for (const rateKey in nonMemberRates) {
			const roomRate = nonMemberRates[rateKey],
						roomRatePlan = ratePlanData.filter(function(rate) {
							return rate.ratePlanCode === roomRate.ratePlanCode
						})

			roomTypePriceButtons.push(
				<BkFlowRoomCardRateStagePriceButton
					key={ roomRate.ratePlanCode }
					activeCurrencyData={activeCurrencyData}
					currentRateCode={currentRateCode}
					currentUpSells={currentUpSells}
					isTaxInclusiveProperty={isTaxInclusiveProperty}
					totalNights={totalNights}
					roomGroup={roomGroup}
					roomRateData={roomRate}
					ratePlanData={roomRatePlan[0]}
					toggleActiveRoom={toggleActiveRoom}
					upSellsToggleEvent={(roomTypeCode, roomRateCode) => upSellsToggleEvent(roomTypeCode, roomRateCode)}
				/>
			)
		}
	}

	return (
		<Slide
			direction="left"
			in={ roomRateStageExpanded }
			timeout={ 500 }
			mountOnEnter={ true }
			unmountOnExit={ true }
			onEntering={() => document.body.classList.add('multi-stage-open')}
			onExit={() => document.body.classList.remove('multi-stage-open')}
		>
			<div className="bk-flow-room__card-rate-stage">
				<div className="u-container">
					<div className="bk-flow-room__card-rate-stage-content">

						<div className="bk-flow-room__card-rate-stage-heading">
							<h2>
								{ yn(process.env.REACT_APP_COMPONENT_BREADCRUMB_BACK_BUTTONS) &&
									<button
										className="btn btn-text-only"
										onClick={ roomRateStageEvent }
									>
										<img src={ backArrow } alt="Return to rooms page" />
										{ hotelLabels && hotelLabels.returnToRooms ? hotelLabels.returnToRooms : 'Return to Rooms' }
									</button>
								}

								{ roomTypeName }&nbsp;{ hotelLabels && hotelLabels.rates ? hotelLabels.rates : 'Rates' }
							</h2>
						</div>

						<div className="bk-flow-room__card-rate-stage-room">
							<BkFlowRoomCardRateStageDetails
								adaDescriptionEvent={adaDescriptionEvent}
								adaDescriptionExpanded={adaDescriptionExpanded}
								cards={cards}
								gallery={ gallery }
								hotelLabels={hotelLabels}
								roomGroup={roomGroup}
							/>

							<div className="bk-flow-room__card-rate-stage-room-rates">{ roomTypePriceButtons }</div>
						</div>
					</div>
				</div>
			</div>
		</Slide>
	)
}

export default BkFlowRoomCardRateStage



// WEBPACK FOOTER //
// ./src/components/room/elements/multi-stage/BkFlowRoomCardRateStage.js